import { EligibilitySummaryComponent } from './shared/eligibility/eligibility-summary.component';
import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {registerLocaleData} from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import moment from 'moment';
import 'moment/locale/nl';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { DragDropModule } from "@angular/cdk/drag-drop";
import { ClipboardModule } from "@angular/cdk/clipboard";
import { TextFieldModule } from "@angular/cdk/text-field";
import { A11yModule } from "@angular/cdk/a11y";
import { Globals } from "./shared/Globals";
import { KpiCardComponent } from './dashboard/widgets/kpi-card/kpi-card.component';
import { WeekHoursComponent } from './dashboard/widgets/week-hours/week-hours.component';
import { HoursHeatmapComponent } from './dashboard/widgets/hours-heatmap/hours-heatmap.component';
import { AssignmentsEndingComponent } from './dashboard/widgets/assignments-ending/assignments-ending.component';
import { TeamRosterComponent } from './dashboard/widgets/team-roster/team-roster.component';
import { TeamHealthStripComponent } from './dashboard/widgets/team-health-strip/team-health-strip.component';
import { CompanyAttentionComponent } from './dashboard/widgets/company-attention/company-attention.component';
import { CompanyUtilTrendComponent } from './dashboard/widgets/company-util-trend/company-util-trend.component';
import { CompanyComingFreeComponent } from './dashboard/widgets/company-coming-free/company-coming-free.component';
import { CompanyBenchForecastComponent } from './dashboard/widgets/company-bench-forecast/company-bench-forecast.component';
import { CompanyMarginByClientComponent } from './dashboard/widgets/company-margin-by-client/company-margin-by-client.component';
import { CapacityForecastComponent } from './dashboard/widgets/capacity-forecast/capacity-forecast.component';
import { HorizonRailComponent } from './dashboard/widgets/horizon-rail/horizon-rail.component';
import { TeamRolloffTableComponent } from './dashboard/widgets/team-rolloff-table/team-rolloff-table.component';
import { DrilldownPanelComponent } from './dashboard/drilldown/drilldown-panel.component';
import { SelfDashboardGridComponent } from './dashboard/self-dashboard-grid/self-dashboard-grid.component';
import { DashboardGridComponent } from './dashboard/dashboard-grid/dashboard-grid.component';
import { TeamDashboardComponent } from './dashboard/team-dashboard/team-dashboard.component';
import { MemberDrillPanelComponent } from './dashboard/member-drill/member-drill-panel.component';

import {
  NbBadgeModule,
  NbButtonGroupModule,
  NbButtonModule,
  NbCardModule, NbCheckboxModule, NbContextMenuModule,
  NbToggleModule,
  NbDatepickerModule,
  NbDialogConfig,
  NbDialogModule, NbFormFieldModule,
  NbGlobalLogicalPosition,
  NbIconModule,
  NbInputModule,
  NbLayoutModule, NbListModule,
  NbMenuModule,
  NbMenuService, NbPopoverModule, NbProgressBarModule, NbRadioModule, NbRouteTabsetModule, NbSearchModule,
  NbSelectModule,
  NbSidebarModule,
  NbSidebarService, NbSpinnerModule,
  NbStepperModule, NbTabsetModule,
  NbThemeModule,
  NbToastrConfig,
  NbToastrModule,
  NbToastrService,
  NbTooltipModule,
  NbAutocompleteModule,
  NbTreeGridModule, NbUserModule, NbDateService
} from '@nebular/theme';
import {NbEvaIconsModule} from '@nebular/eva-icons';
import {HeaderComponent} from './header/header.component';
import {SidebarComponent} from './sidebar/sidebar.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import { WidgetHostComponent } from './dashboard/widget-host/widget-host.component';
import {ProjectsComponent} from './project/projects.component';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import { TimeframeDisplayComponent } from './timeframe-display/timeframe-display.component';
import { ApiInterceptor } from "./shared/api.incercepter";
import { UsersComponent } from './user/users.component';
import { ValueOfPipe } from './pipes/value-of.pipe';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { DirectoryAssignerComponent } from './directory-assigner/directory-assigner.component';
import { NewProjectComponent } from './project/new-project.component';
import { ConfirmDialogComponent } from './dialogs/confirm-dialog/confirm-dialog.component';
import { ProjectComponent } from './project/project.component';
import { UserComponent } from './user/user.component';
import { SuggestedVacanciesComponent } from './user/suggested-vacancies/suggested-vacancies.component';
import { DirectoryComponent } from './directories/directory/directory.component';
import { SkillCurationComponent } from './directories/skill-curation/skill-curation.component';
import { TeamConfigDrawerComponent } from './directories/team-config-drawer/team-config-drawer.component';
import { SortedPipe } from './pipes/sorted.pipe';
import { EditDialogComponent } from './dialogs/edit-dialog/edit-dialog.component';
import { PagerModule } from './pager/pager.module';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { NewUserComponent } from './user/new-user.component';
import { TaberComponent } from './controls/taber/taber.component';
import { RegisterComponent } from './register/register.component';
import { CallbackComponent } from './callback/callback.component';
import { SettingsComponent } from './settings/settings.component';
import { SearchFieldComponent } from './search-field/search-field.component';
import { SearchComponent } from './search/search.component';
import { UploaderComponent } from './controls/uploader/uploader.component';
import { FilePreviewComponent } from './file-preview/file-preview.component';
import { CookieService } from "ngx-cookie-service";
import {NbMomentDateModule} from "@nebular/moment";
import {AppDateService} from "./shared/app-date.service";
import {DateFieldDirective} from "./shared/date-field.directive";
import {UserDialogComponent} from "./dialogs/popup-dialog/user-dialog.component";
import { PopupDialogComponent } from "./dialogs/popup-dialog/popup-dialog.component";
import {InfiniteScrollModule} from "ngx-infinite-scroll";
import {OverlayModule} from "@angular/cdk/overlay";
import { AutofocusDirective } from './directives/autofocus.directive';
import { UserProjectAssignerComponent } from './controls/user-project-assigner/user-project-assigner.component';
import {NgxIntlTelInputModule} from "ngx-intl-tel-input";
import { CapacityManagerComponent } from './controls/capacity-manager/capacity-manager.component';
import { ScheduleDisplayPipe } from './pipes/schedule-display.pipe';
import { TableEditorComponent } from './controls/table-editor/table-editor.component';
import { LeaveDialogComponent } from './dialogs/popup-dialog/leave-dialog.component';
import { LeaveComponent } from './user/leave/leave.component';
import { UserScheduleChartComponent } from './charts/bar-chart/user-schedule-chart.component';
import { PieChartComponent } from './charts/pie-chart/pie-chart.component';
import { ChartComponent } from './charts/chart/chart.component';
import { SparklineComponent } from './charts/sparkline/sparkline.component';
import { AreaChartComponent } from './charts/area-chart/area-chart.component';
import { LeaveManagerComponent } from './controls/leave-manager/leave-manager.component';
import {NgxCurrencyDirective} from "ngx-currency";
import { DualAxisDirective } from './directives/dual-axis.directive';
import { GridRowHoverDirective } from './directives/grid-row-hover.directive';
import { FilterDialogComponent } from './dialogs/filter-dialog/filter-dialog.component';
import { TableOptionsComponent } from './settings/table-options/table-options.component';
import { TableOptionsButtonComponent } from './settings/table-options/table-options-button.component';
import { SortOptionsComponent } from './settings/table-options/sort-options.component';
import { MapEditorComponent } from './controls/map-editor/map-editor.component';
import { DualSliderComponent } from './controls/dual-slider/dual-slider.component';
import { DualAxisComponent } from './dual-axis/dual-axis.component';
import { PluralPipe } from './pipes/plural.pipe';
import { CurClientSelectorComponent } from './controls/cur-client-selector/cur-client-selector.component';
import { ClientComponent } from './clients/client.component';
import { ClientOverviewTabComponent } from './clients/client-overview-tab/client-overview-tab.component';
import { ClientCvsTabComponent } from './clients/client-cvs-tab/client-cvs-tab.component';
import { MovingPlaceholderDirective } from './directives/moving-placeholder.directive';
import { SmartPasteDirective } from './directives/smart-paste.directive';
import {
  ErroringDirective,
  ForwardFocusDirective,
  NativeElementInjectorDirective
} from './directives/erroring.directive';
import { NewClientComponent } from './clients/new-client.component';
import { NewClientDialogComponent } from './clients/new-client-dialog/new-client-dialog.component';
import { ClientOrganizationSectionComponent } from './clients/client-organization-section/client-organization-section.component';
import { ClientCrmSectionComponent } from './clients/client-crm-section/client-crm-section.component';
import { ClientQuotesSectionComponent } from './clients/client-quotes-section/client-quotes-section.component';
import { OrganizationAliasesComponent } from './clients/organization-aliases/organization-aliases.component';
import { PhotoUploaderComponent } from './controls/uploader/photo-uploader.component';
import {ImageCropperModule} from "ngx-image-cropper";
import { CropDialogComponent } from './dialogs/crop-dialog/crop-dialog.component';
import { PhotoWellComponent } from './file-preview/photo-well.component';
import { CopiableComponent } from './controls/copiable/copiable.component';
import { PlacesEditorComponent } from './controls/places-editor/places-editor.component';
import { QuestionDirectoryComponent } from './directories/question-directory/question-directory.component';
import { ScaleEditorComponent } from './controls/scale-editor/scale-editor.component';

import { PasswordComponent } from './controls/password/password.component';
import {AuthService} from "./shared/auth.service";
import { ExperienceAssignerComponent } from './controls/experience-assigner/experience-assigner.component';
import { ExperienceEditorComponent } from './controls/experience-assigner/experience-editor/experience-editor.component';
import { SpanPipe } from './pipes/span.pipe';
import { LocaleDatePipe } from './pipes/locale-date.pipe';
import { FramePipe } from './pipes/frame.pipe';
import { DateifyPipe } from './pipes/dateify.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import { RoundPipe } from './pipes/round.pipe';
import { FormatDescriptionPipe } from './pipes/format-description.pipe';
import { TableObjectComponent } from './table-object/table-object.component';
import { ActivatedComponentsDirective } from './directives/activated-components.directive';
import { ScoreSelectorComponent } from './controls/score-selector/score-selector.component';
import { ArchiveBinComponent } from './archive-bin/archive-bin.component';
import { TimelineChartComponent } from './charts/timeline-chart/timeline-chart.component';
import { SVGComponent } from './svg/svg.component';
import { MultiButtonComponent } from './controls/multi-button/multi-button.component';
import { TimesheetComponent } from './timesheet/timesheet.component';
import { WeekTripsComponent } from './timesheet/week-trips/week-trips.component';
import { TripEndComponent } from './timesheet/week-trips/trip-end/trip-end.component';
import { ApprovalStripComponent } from './registration/approval-strip/approval-strip.component';
import { KilometresComponent } from './registration/kilometres/kilometres.component';
import { HomeAddressComponent } from './user/home-address/home-address.component';
import { ReimbursementRatesComponent } from './clients/reimbursement-rates/reimbursement-rates.component';
import { InvoicingCompanyComponent } from './clients/invoicing-company/invoicing-company.component';
import { CompanyTabComponent } from './clients/company-tab/company-tab.component';
import { InvoicingClientComponent } from './clients/invoicing-client/invoicing-client.component';
import { InvoicingProjectComponent } from './project/invoicing-project/invoicing-project.component';
import { VatOptionsComponent } from './clients/vat-options/vat-options.component';
import { KmCostTypeComponent } from './clients/km-cost-type/km-cost-type.component';
import { QuoteSettingsComponent } from './clients/quote-settings/quote-settings.component';
import { QuoteComponent } from './crm/quote/quote.component';
import { QuoteStatusComponent } from './crm/quote-status/quote-status.component';
import { QuoteListComponent } from './crm/quote-list/quote-list.component';
import { QuotesOverviewComponent } from './crm/quotes-overview/quotes-overview.component';
import { ExportDialogComponent } from './timesheet/export-dialog/export-dialog.component';
import { HoursOverviewDialogComponent } from './project/hours-overview-dialog/hours-overview-dialog.component';
import { ProjectInvoicesComponent } from './project/project-invoices/project-invoices.component';
import { NewInvoiceDialogComponent } from './project/new-invoice-dialog/new-invoice-dialog.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { InvoicesComponent } from './invoices/invoices.component';
import { InvoiceStatusComponent } from './invoice/invoice-status/invoice-status.component';
import { MenuDialogComponent } from './dialogs/menu-dialog/menu-dialog.component';
import { UserPickerComponent } from './controls/user-picker/user-picker.component';
import { MarketVacanciesListComponent } from './market-vacancies/market-vacancies-list.component';
import { IntakeListComponent } from './intake/intake-list/intake-list.component';
import { IntakeDatePipe } from './intake/intake-date/intake-date.pipe';
import { IntakeVerdictPanelComponent } from './intake/intake-verdict-panel/intake-verdict-panel.component';
import { IntakeMailViewComponent } from './intake/intake-mail-view/intake-mail-view.component';
import { IntakeAddressBlockComponent } from './intake/intake-address-block/intake-address-block.component';
import { IntakeCopyComponent } from './intake/intake-copy/intake-copy.component';
import { MarketVacancyDetailComponent } from './market-vacancies/market-vacancy-detail.component';
import { CreateVacancyDialogComponent } from './market-vacancies/create-vacancy-dialog/create-vacancy-dialog.component';
import { MarketFilterSheetComponent } from './market-vacancies/market-filter-sheet/market-filter-sheet.component';
import { OrganizationsTableComponent } from './platform/organizations-table.component';
import { OpportunitiesComponent } from './crm/opportunities/opportunities.component';
import { OpportunityDetailComponent } from './crm/opportunity-detail/opportunity-detail.component';
import { AddSubmissionDialogComponent } from './crm/opportunity-detail/add-submission-dialog/add-submission-dialog.component';
import { SubmissionsComponent } from './crm/submissions/submissions.component';
import { OrganizationsComponent } from './crm/organizations/organizations.component';
import { OrganizationDetailComponent } from './crm/organizations/organization-detail/organization-detail.component';
import { LossReasonDialogComponent } from './crm/submissions/loss-reason-dialog.component';
import { InterviewDateDialogComponent } from './crm/submissions/interview-date-dialog.component';
import { ConvertProjectDialogComponent } from './crm/submissions/convert-project-dialog/convert-project-dialog.component';
import { SubmissionDetailComponent } from './crm/submission-detail/submission-detail.component';
import { CrmActivityLogComponent } from './crm/activity-log/crm-activity-log.component';
import { CrmTimelineComponent } from './crm/activity-timeline/crm-timeline.component';
import { DescriptionFitWarningComponent } from './match-card/description-fit-warning.component';
import { PendingApprovalsComponent } from './time-approvals/pending-approvals.component';
import { TimeApprovalDetailComponent } from './time-approvals/time-approval-detail.component';
import { ReasonDialogComponent } from './dialogs/reason-dialog/reason-dialog.component';
import { CvModule } from './cv/cv.module';
import { ControlsModule } from './controls/controls.module';
import { CvGeneratorPageComponent } from './cv/cv-generator-page/cv-generator-page.component';
import { CvTailorComponent } from './cv/cv-tailor/cv-tailor.component';
// CvListComponent lives in AppModule (not CvModule) so it can reach
// DualAxisComponent, which is also declared here.
import { CvListComponent } from './cv/cv-list/cv-list.component';
import { TailoredCvListComponent } from './cv/cv-list/tailored-cv-list.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { USE_METRICS_API } from './shared/metrics.service';

const toastConfig = <Partial<NbToastrConfig>>{
  preventDuplicates: false,
  duration: 3500,
  destroyByClick: true,
  position: NbGlobalLogicalPosition.TOP_END,
  duplicatesBehaviour: 'all',
  status: 'basic'
};

const dialogConfig = <Partial<NbDialogConfig>>{
  autoFocus: true,
  hasBackdrop: true,
  closeOnEsc: true
};

// ValueOfPipe builds a DatePipe, and the number and currency pipes format, in the UI language, which throws without its locale data.
registerLocaleData(localeNl, 'nl');
// The datepicker (NbMomentDateService.setLocale) reads moment's nl locale data. It is imported
// explicitly so it does not depend on the builder bundling moment's dynamic locale require, and
// importing a locale also makes it moment's global default, so put the global back to English.
moment.locale('en');

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './lang/', '.json?v=' + Globals.version);
}

@NgModule({ declarations: [
        AppComponent,
        DateFieldDirective,
        OrganizationsTableComponent,
        HeaderComponent,
        SidebarComponent,
        DashboardComponent,
        WidgetHostComponent,
        SelfDashboardGridComponent,
        DashboardGridComponent,
        TeamDashboardComponent,
        KpiCardComponent,
        WeekHoursComponent,
        HoursHeatmapComponent,
        AssignmentsEndingComponent,
        TeamRosterComponent,
        TeamHealthStripComponent,
        CompanyAttentionComponent,
        CompanyUtilTrendComponent,
        CompanyComingFreeComponent,
        CompanyBenchForecastComponent,
        CompanyMarginByClientComponent,
        CapacityForecastComponent,
        HorizonRailComponent,
        TeamRolloffTableComponent,
        DrilldownPanelComponent,
        MemberDrillPanelComponent,
        ProjectsComponent,
        TimeframeDisplayComponent,
        UsersComponent,
        ValueOfPipe,
        DirectoryAssignerComponent,
        NewProjectComponent,
        ConfirmDialogComponent,
        ProjectComponent,
        UserComponent,
        SuggestedVacanciesComponent,
        DirectoryComponent,
        SkillCurationComponent,
        TeamConfigDrawerComponent,
        SortedPipe,
        EditDialogComponent,
        LoginComponent,
        LogoutComponent,
        NewUserComponent,
        TaberComponent,
        RegisterComponent,
        CallbackComponent,
        SettingsComponent,
        SearchFieldComponent,
        SearchComponent,
        UploaderComponent,
        FilePreviewComponent,
        UserDialogComponent,
        PopupDialogComponent,
        AutofocusDirective,
        ForwardFocusDirective,
        NativeElementInjectorDirective,
        UserProjectAssignerComponent,
        CapacityManagerComponent,
        ScheduleDisplayPipe,
        TableEditorComponent,
        LeaveDialogComponent,
        LeaveComponent,
        UserScheduleChartComponent,
        PieChartComponent,
        ChartComponent,
        LeaveManagerComponent,
        DualAxisDirective,
        GridRowHoverDirective,
        FilterDialogComponent,
        TableOptionsComponent,
        TableOptionsButtonComponent,
        SortOptionsComponent,
        MapEditorComponent,
        DualSliderComponent,
        DualAxisComponent,
        CvListComponent,
        TailoredCvListComponent,
        PluralPipe,
        CurClientSelectorComponent,
        ClientComponent,
        ClientOverviewTabComponent,
        ClientCvsTabComponent,
        CvGeneratorPageComponent,
        CvTailorComponent,
        MovingPlaceholderDirective,
        SmartPasteDirective,
        ErroringDirective,
        NewClientComponent,
        NewClientDialogComponent,
        ClientOrganizationSectionComponent,
        ClientCrmSectionComponent,
        ClientQuotesSectionComponent,
        OrganizationAliasesComponent,
        PhotoUploaderComponent,
        CropDialogComponent,
        PhotoWellComponent,
        CopiableComponent,
        PlacesEditorComponent,
        QuestionDirectoryComponent,
        ScaleEditorComponent,
        PasswordComponent,
        ExperienceAssignerComponent,
        ExperienceEditorComponent,
        SpanPipe,
        LocaleDatePipe,
        FramePipe,
        DateifyPipe,
        FilterPipe,
        RoundPipe,
        FormatDescriptionPipe,
        TableObjectComponent,
        ActivatedComponentsDirective,
        ScoreSelectorComponent,
        ArchiveBinComponent,
        TimelineChartComponent,
        SparklineComponent,
        AreaChartComponent,
        SVGComponent,
        MultiButtonComponent,
        TimesheetComponent,
        WeekTripsComponent,
        TripEndComponent,
        ApprovalStripComponent,
        KilometresComponent,
        HomeAddressComponent,
        ReimbursementRatesComponent,
        InvoicingCompanyComponent,
        CompanyTabComponent,
        InvoicingClientComponent,
        InvoicingProjectComponent,
        VatOptionsComponent,
        KmCostTypeComponent,
        QuoteSettingsComponent,
        QuoteComponent,
        QuoteStatusComponent,
        QuoteListComponent,
        QuotesOverviewComponent,
        ExportDialogComponent,
        HoursOverviewDialogComponent,
        ProjectInvoicesComponent,
        NewInvoiceDialogComponent,
        InvoiceComponent,
        InvoicesComponent,
        InvoiceStatusComponent,
        MenuDialogComponent,
        UserPickerComponent,
        MarketVacanciesListComponent,
        IntakeListComponent,
        IntakeDatePipe,
        IntakeMailViewComponent,
        IntakeVerdictPanelComponent,
        IntakeAddressBlockComponent,
        IntakeCopyComponent,
        MarketVacancyDetailComponent,
        CreateVacancyDialogComponent,
        OpportunitiesComponent,
        OpportunityDetailComponent,
        AddSubmissionDialogComponent,
        SubmissionsComponent,
        OrganizationsComponent,
        OrganizationDetailComponent,
        LossReasonDialogComponent,
        InterviewDateDialogComponent,
        ConvertProjectDialogComponent,
        SubmissionDetailComponent,
        CrmActivityLogComponent,
        CrmTimelineComponent,
        MarketFilterSheetComponent,
        DescriptionFitWarningComponent,
        PendingApprovalsComponent,
        TimeApprovalDetailComponent,
        ReasonDialogComponent
    ],
    bootstrap: [AppComponent], imports: [EligibilitySummaryComponent, NgxCurrencyDirective,
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        ClipboardModule,
        TextFieldModule,
        NbThemeModule.forRoot({ name: 'teamer' }),
        NbLayoutModule,
        NbSidebarModule,
        NbEvaIconsModule,
        NbMenuModule.forRoot(),
        NbToastrModule.forRoot(toastConfig),
        NbCardModule,
        NbTooltipModule,
        NbStepperModule,
        NbIconModule,
        NbSelectModule,
        NbButtonModule,
        NbCheckboxModule,
        NbToggleModule,
        NbTreeGridModule,
        DragDropModule,
        A11yModule,
        NbRadioModule,
        NbUserModule,
        NbButtonGroupModule,
        NbTabsetModule,
        // NbDatepickerModule pulls in NbCalendarModule, which provides NbDateService itself
        // (defaulting to NbNativeDateService, whose parse() can't honor a format string and
        // falls back to native Date.parse — month-first). NbMomentDateModule must be imported
        // AFTER it so Moment's NbDateService provider is the one that wins (see #1175).
        NbDatepickerModule.forRoot(),
        NbMomentDateModule,
        NbProgressBarModule,
        NbSearchModule,
        NbContextMenuModule,
        NgxIntlTelInputModule,
        NbDialogModule.forRoot(dialogConfig),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        FormsModule,
        ReactiveFormsModule,
        NbInputModule,
        NbRouteTabsetModule,
        NbSpinnerModule,
        InfiniteScrollModule,
        OverlayModule,
        ImageCropperModule,
        NbFormFieldModule,
        NbPopoverModule,
        NbListModule,
        NbBadgeModule,
        NbAutocompleteModule,
        PagerModule,
        ControlsModule,
        CvModule,
        NgxEchartsModule.forRoot({ echarts: () => import('echarts') })], providers: [
        {provide: NbDateService, useClass: AppDateService},
        NbSidebarService,
        NbMenuService,
        TranslateService,
        NbToastrService,
        CookieService,
        AuthService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiInterceptor,
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: (auth: AuthService) => () => auth.bootstrap(),
            deps: [AuthService],
            multi: true
        },
        { provide: USE_METRICS_API, useValue: true },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
